const validate = {
  rules: {
    titulo: {
      required: true,
    },
    descricao: {
      required: true,
    },
    imagem: {
      required: true,
    },
  },
  messages: {
    titulo: "O título é obrigatório.",
    descricao: "A descrição é obrigatória.",
    imagem: "A imagem é obrigatória.",
  },
};

export default validate;
